(() => {
  const DEBUG = !!window.EPASS_DEBUG;

  const MOUNT_ID = "epass-gbp-service";
  const HIDDEN_ID = "epass-gbp-service-json";
  const PROPERTY_NAME = "_epass_gbp_service";

  function log(...args) {
    if (DEBUG) console.log("[EPASS-GBP]", ...args);
  }

  function escapeHtml(s) {
    return String(s ?? "").replace(/[&<>"']/g, (m) => ({
      "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
    }[m]));
  }

  function injectStylesOnce() {
    if (document.getElementById("epass-gbp-style")) return;
    const style = document.createElement("style");
    style.id = "epass-gbp-style";
    style.textContent = `
      #${MOUNT_ID} .epass-wrap{margin-top:14px;border:1px solid rgba(0,0,0,.12);border-radius:12px;padding:14px}
      #${MOUNT_ID} .epass-title{margin:0 0 6px;font-size:16px}
      #${MOUNT_ID} .epass-hint{margin:0 0 12px;font-size:13px;opacity:.85}
      #${MOUNT_ID} .epass-card{border:1px solid rgba(0,0,0,.12);border-radius:12px;overflow:hidden}
      #${MOUNT_ID} .epass-card__head{display:flex;justify-content:space-between;gap:10px;align-items:center;padding:10px 12px;background:rgba(0,0,0,.04);user-select:none}
      #${MOUNT_ID} .epass-card__body{display:grid;gap:10px;padding:12px}
      #${MOUNT_ID} .epass-field__label{font-size:12px;opacity:.8;margin-bottom:6px}
      #${MOUNT_ID} .epass-input{width:100%;padding:10px 11px;border-radius:10px;border:1px solid rgba(0,0,0,.18);outline:none}
      #${MOUNT_ID} .epass-input:focus{border-color:rgba(0,0,0,.45)}
      #${MOUNT_ID} .epass-row{display:flex;gap:10px;flex-wrap:wrap;align-items:center}
      #${MOUNT_ID} .epass-check{display:flex;gap:8px;align-items:center;font-size:12px;opacity:.9}
      #${MOUNT_ID} .epass-check input{transform:translateY(1px)}
      #${MOUNT_ID} .epass-error{margin-top:10px;padding:10px 12px;border-radius:10px;background:rgba(240,68,56,.12);color:rgba(150,20,20,1);font-size:13px}
      #${MOUNT_ID} table{width:100%;border-collapse:collapse}
      #${MOUNT_ID} th,#${MOUNT_ID} td{padding:8px;border:1px solid rgba(0,0,0,.12);font-size:13px}
      #${MOUNT_ID} select.epass-input{background:#fff}
    `;
    document.head.appendChild(style);
  }

  function findProductForm(fromEl) {
    return (
      fromEl?.closest?.('form[action^="/cart/add"], form[action*="/cart/add"], form[action*="/cart/add.js"], form[data-type="add-to-cart-form"], .product-form form') ||
      document.querySelector('form[action^="/cart/add"], form[action*="/cart/add"], form[action*="/cart/add.js"], form[data-type="add-to-cart-form"], .product-form form') ||
      null
    );
  }

  const state = {
    schema_version: 1,
    company_name: "",
    address: "",
    city: "",
    zip: "",
    activity: "",
    phone: "",
    email: "",
    lieu_public: "",
    livraison_visite: "",
    hours: {
      lundi: { open: "09:00", close: "18:00" },
      mardi: { open: "09:00", close: "18:00" },
      mercredi: { open: "09:00", close: "18:00" },
      jeudi: { open: "09:00", close: "18:00" },
      vendredi: { open: "09:00", close: "18:00" },
      samedi: { open: "09:00", close: "18:00" },
      dimanche: { open: "09:00", close: "18:00" },
    },
    created_at: null
  };

  function serialize() {
    if (!state.created_at) state.created_at = new Date().toISOString();
    return JSON.stringify(state);
  }

  function timeOptionsHtml(selected) {
    const out = [];
    for (let h = 0; h <= 23; h++) {
      const v = String(h).padStart(2, "0") + ":00";
      out.push(`<option value="${v}" ${v === selected ? "selected" : ""}>${v}</option>`);
    }
    return out.join("");
  }

  function syncHidden() {
    const hidden = document.getElementById(HIDDEN_ID);
    if (!hidden) return;
    hidden.name = `properties[${PROPERTY_NAME}]`;
    hidden.value = serialize();
  }

  function render(mount) {
    mount.innerHTML = `
      <div class="epass-wrap">
        <h3 class="epass-title">Informations pour créer votre fiche Google</h3>
        <div class="epass-card">
          <div class="epass-card__head">
            <div>Détails de l'établissement</div>
            <small>obligatoire</small>
          </div>

          <div class="epass-card__body">
            <div>
              <div class="epass-field__label">Nom de l'entreprise</div>
              <input class="epass-input" id="epass_company" type="text" placeholder="Votre entreprise" value="${escapeHtml(state.company_name)}" required>
            </div>

            <div>
              <div class="epass-field__label">Adresse</div>
              <input class="epass-input" id="epass_address" type="text" placeholder="Votre adresse" value="${escapeHtml(state.address)}" required>
            </div>

            <div class="epass-row">
              <div style="flex:1;min-width:180px">
                <div class="epass-field__label">Ville</div>
                <input class="epass-input" id="epass_city" type="text" placeholder="Votre ville" value="${escapeHtml(state.city)}" required>
              </div>
              <div style="width:160px;min-width:140px">
                <div class="epass-field__label">Code Postal</div>
                <input class="epass-input" id="epass_zip" type="text" placeholder="Code Postal" value="${escapeHtml(state.zip)}" required>
              </div>
            </div>

            <div>
              <div class="epass-field__label">Secteur d'activité</div>
              <input class="epass-input" id="epass_activity" type="text" placeholder="Votre secteur d'activité" value="${escapeHtml(state.activity)}" required>
            </div>

            <div class="epass-row">
              <div style="flex:1;min-width:180px">
                <div class="epass-field__label">Téléphone</div>
                <input class="epass-input" id="epass_phone" type="text" placeholder="+33..." value="${escapeHtml(state.phone)}" required>
              </div>
              <div style="flex:1;min-width:220px">
                <div class="epass-field__label">Email</div>
                <input class="epass-input" id="epass_email" type="email" placeholder="Votre email" value="${escapeHtml(state.email)}" required>
              </div>
            </div>

            <div>
              <div class="epass-field__label">Lieu physique qui accueille du public ?</div>
              <div class="epass-row">
                <label class="epass-check">
                  <input type="radio" name="epass_lieu_public" value="oui" ${state.lieu_public === "oui" ? "checked" : ""}>
                  Oui
                </label>
                <label class="epass-check">
                  <input type="radio" name="epass_lieu_public" value="non" ${state.lieu_public === "non" ? "checked" : ""}>
                  Non
                </label>
              </div>
            </div>

            <div>
              <div class="epass-field__label">Livraisons / visites à domicile ou au bureau ?</div>
              <div class="epass-row">
                <label class="epass-check">
                  <input type="radio" name="epass_livraison_visite" value="oui" ${state.livraison_visite === "oui" ? "checked" : ""}>
                  Oui
                </label>
                <label class="epass-check">
                  <input type="radio" name="epass_livraison_visite" value="non" ${state.livraison_visite === "non" ? "checked" : ""}>
                  Non
                </label>
              </div>
            </div>

            <div>
              <div class="epass-field__label">Horaires d'ouverture</div>
              <table>
                <tr><th>Jour</th><th>Ouverture</th><th>Fermeture</th></tr>
                ${["lundi","mardi","mercredi","jeudi","vendredi","samedi","dimanche"].map((d) => `
                  <tr>
                    <td style="text-transform:capitalize">${escapeHtml(d)}</td>
                    <td>
                      <select class="epass-input epass-open" data-day="${escapeHtml(d)}">
                        ${timeOptionsHtml(state.hours[d].open)}
                      </select>
                    </td>
                    <td>
                      <select class="epass-input epass-close" data-day="${escapeHtml(d)}">
                        ${timeOptionsHtml(state.hours[d].close)}
                      </select>
                    </td>
                  </tr>
                `).join("")}
              </table>
            </div>
          </div>
        </div>

        <div class="epass-error" id="epass-gbp-error" hidden></div>
      </div>
    `;

    const error = mount.querySelector("#epass-gbp-error");
    const $ = (sel) => mount.querySelector(sel);

    const validate = () => {
      error.hidden = true;
      error.textContent = "";

      const required = [
        ["Nom entreprise", state.company_name],
        ["Adresse", state.address],
        ["Ville", state.city],
        ["Code postal", state.zip],
        ["Secteur d'activité", state.activity],
        ["Téléphone", state.phone],
        ["Email", state.email],
      ];

      for (const [label, val] of required) {
        if (!String(val || "").trim()) {
          error.hidden = false;
          error.textContent = `Champ requis manquant : ${label}`;
          return false;
        }
      }
      if (!state.lieu_public) {
        error.hidden = false;
        error.textContent = `Merci de répondre : "lieu public"`;
        return false;
      }
      if (!state.livraison_visite) {
        error.hidden = false;
        error.textContent = `Merci de répondre : "livraison / visite"`;
        return false;
      }
      return true;
    };

    // Expose validator
    mount.__epassValidate = validate;

    // Wire inputs -> state -> hidden
    $("#epass_company").addEventListener("input", (e) => { state.company_name = (e.target.value || "").trim(); syncHidden(); });
    $("#epass_address").addEventListener("input", (e) => { state.address = (e.target.value || "").trim(); syncHidden(); });
    $("#epass_city").addEventListener("input", (e) => { state.city = (e.target.value || "").trim(); syncHidden(); });
    $("#epass_zip").addEventListener("input", (e) => { state.zip = (e.target.value || "").trim(); syncHidden(); });
    $("#epass_activity").addEventListener("input", (e) => { state.activity = (e.target.value || "").trim(); syncHidden(); });
    $("#epass_phone").addEventListener("input", (e) => { state.phone = (e.target.value || "").trim(); syncHidden(); });
    $("#epass_email").addEventListener("input", (e) => { state.email = (e.target.value || "").trim(); syncHidden(); });

    mount.querySelectorAll('input[name="epass_lieu_public"]').forEach((r) => {
      r.addEventListener("change", () => { state.lieu_public = r.value; syncHidden(); });
    });

    mount.querySelectorAll('input[name="epass_livraison_visite"]').forEach((r) => {
      r.addEventListener("change", () => { state.livraison_visite = r.value; syncHidden(); });
    });

    mount.querySelectorAll(".epass-open").forEach((sel) => {
      sel.addEventListener("change", () => {
        const day = sel.dataset.day;
        if (!day) return;
        state.hours[day].open = sel.value;
        syncHidden();
      });
    });

    mount.querySelectorAll(".epass-close").forEach((sel) => {
      sel.addEventListener("change", () => {
        const day = sel.dataset.day;
        if (!day) return;
        state.hours[day].close = sel.value;
        syncHidden();
      });
    });

    syncHidden();
  }

  function hardSyncHiddenNow() {
    syncHidden();
  }

  // Optional interceptor: useful if theme adds via AJAX /cart/add
  let interceptorInstalled = false;
  function installCartAddInterceptor() {
    // EPASS-CORE injecte désormais _epass_gbp_service sur /cart/add.
    if (window.__EPASS_CORE_INSTALLED__) return;
    if (interceptorInstalled) return;
    interceptorInstalled = true;

    if (window.__EPASS_GBP_CARTADD_PATCHED) return;
    window.__EPASS_GBP_CARTADD_PATCHED = true;

    const cartAddRe = /\/cart\/add(\.js)?(\?|$)/i;

    const getValue = () => {
      const el = document.getElementById(HIDDEN_ID);
      return (el?.value || "").trim();
    };

    const ensureHeadersObj = (h) => {
      if (!h) return {};
      if (h instanceof Headers) {
        const obj = {};
        h.forEach((val, key) => (obj[key] = val));
        return obj;
      }
      return { ...h };
    };

    const setHeader = (init, key, val) => {
      init.headers = ensureHeadersObj(init.headers);
      init.headers[key] = val;
    };

    const _fetch = window.fetch;
    if (typeof _fetch === "function") {
      window.fetch = function (input, init) {
        try {
          const url =
            typeof input === "string"
              ? input
              : (input && typeof input.url === "string" ? input.url : "");

          if (!url || !cartAddRe.test(url) || !init) {
            return _fetch.call(this, input, init);
          }

          let val = getValue();
          if (!val) {
            hardSyncHiddenNow();
            val = getValue();
          }
          if (!val) return _fetch.call(this, input, init);

          const nextInit = { ...init };
          const body = nextInit.body;

          if (body instanceof FormData) {
            body.set(`properties[${PROPERTY_NAME}]`, val);
            nextInit.body = body;
            return _fetch.call(this, input, nextInit);
          }

          if (body instanceof URLSearchParams) {
            body.set(`properties[${PROPERTY_NAME}]`, val);
            nextInit.body = body;
            setHeader(nextInit, "Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
            return _fetch.call(this, input, nextInit);
          }

          const headersObj = ensureHeadersObj(nextInit.headers);
          const ct = String(headersObj["Content-Type"] || headersObj["content-type"] || "").toLowerCase();

          if (typeof body === "string" && ct.includes("application/json")) {
            try {
              const obj = JSON.parse(body);
              if (obj && typeof obj === "object") {
                obj.properties = obj.properties && typeof obj.properties === "object" ? obj.properties : {};
                obj.properties[PROPERTY_NAME] = val;
                nextInit.body = JSON.stringify(obj);
                setHeader(nextInit, "Content-Type", "application/json");
                return _fetch.call(this, input, nextInit);
              }
            } catch (_) {}
          }

          if (typeof body === "string") {
            const usp = new URLSearchParams(body);
            usp.set(`properties[${PROPERTY_NAME}]`, val);
            nextInit.body = usp.toString();
            setHeader(nextInit, "Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
            return _fetch.call(this, input, nextInit);
          }

          return _fetch.call(this, input, init);
        } catch (err) {
          log("fetch interceptor error", err);
          return _fetch.call(this, input, init);
        }
      };
    }

    const _open = XMLHttpRequest.prototype.open;
    const _send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__epassUrl = url;
      return _open.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      try {
        const url = String(this.__epassUrl || "");
        if (!cartAddRe.test(url)) return _send.apply(this, arguments);

        let val = getValue();
        if (!val) {
          hardSyncHiddenNow();
          val = getValue();
        }
        if (!val) return _send.apply(this, arguments);

        if (body instanceof FormData) {
          body.set(`properties[${PROPERTY_NAME}]`, val);
          return _send.call(this, body);
        }

        if (typeof body === "string") {
          const usp = new URLSearchParams(body);
          usp.set(`properties[${PROPERTY_NAME}]`, val);
          return _send.call(this, usp.toString());
        }

        return _send.apply(this, arguments);
      } catch (err) {
        log("xhr interceptor error", err);
        return _send.apply(this, arguments);
      }
    };

    log("Cart add interceptor installed");
  }

  function boot() {
    const mount = document.getElementById(MOUNT_ID);
    const hidden = document.getElementById(HIDDEN_ID);
    if (!mount || !hidden) return false;

    const form = findProductForm(mount) || findProductForm(hidden);
    if (!form) return false;

    injectStylesOnce();
    render(mount);

    // bind submit validation once
    if (form.dataset.epassGbpBound !== "1") {
      form.dataset.epassGbpBound = "1";
      form.addEventListener("submit", (e) => {
        hardSyncHiddenNow();
        if (typeof mount.__epassValidate === "function" && !mount.__epassValidate()) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }

    installCartAddInterceptor();
    return true;
  }

  function bootWithObserver() {
    const tryBoot = () => {
      try { return boot(); } catch (e) { log("boot error", e); return false; }
    };

    if (tryBoot()) return;

    const obs = new MutationObserver(() => {
      if (tryBoot()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  // Exposé pour EPASS-CORE : resynchronise le champ caché _epass_gbp_service
  // juste avant un /cart/add.
  window.EPASS_GBP = {
    syncHidden: () => {
      try { hardSyncHiddenNow(); } catch (_) {}
    },
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootWithObserver);
  } else {
    bootWithObserver();
  }
})();
